import { Autocomplete, Box, FormControl, TextField, Grid } from '@mui/material';
import { SyntheticEvent, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

export type bedrockChatFormData = {
  llm_model_name: string;
  token_size: string;
};

const BuildWiseGPTForm = () => {
  const defaultFormState: bedrockChatFormData = {
    ...(JSON.parse(String(sessionStorage.getItem('bedrockChatForm'))) || {
      llm_model_name: 'anthropic.claude-3-sonnet-20240229-v1:0',
      token_size: '5000',
    }),
  };
  const { control, setValue, watch } = useForm<bedrockChatFormData>({
    mode: 'all',
    defaultValues: defaultFormState,
  });
  const llmModelOptions = [
    { label: 'a121_jamba', value: 'ai21.jamba-instruct-v1:0' },
    { label: 'command_r', value: 'cohere.command-r-v1:0' },
    { label: 'command_r_plus', value: 'cohere.command-r-plus-v1:0' },
    { label: 'haiku_model', value: 'anthropic.claude-3-haiku-20240307-v1:0' },
    { label: 'sonnet_3_model', value: 'anthropic.claude-3-sonnet-20240229-v1:0' },
    { label: 'sonnet_3_5_model', value: 'anthropic.claude-3-5-sonnet-20240620-v1:0' },
  ];
  const watchedValues = watch(['llm_model_name', 'token_size']);

  useEffect(() => {
    sessionStorage.setItem(
      'bedrockChatForm',
      JSON.stringify({ llm_model_name: watchedValues[0], token_size: watchedValues[1] }),
    );
  }, [watchedValues]);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={12} lg={6}>
          <Controller
            control={control}
            render={({ field: { ref, ...field }, fieldState }) => (
              <FormControl fullWidth>
                <Autocomplete
                  {...field}
                  autoHighlight
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  value={
                    field.value
                      ? llmModelOptions.find(
                          (projectType) => projectType.value === field.value,
                        ) || {
                          label: field.value,
                          value: field.value,
                        }
                      : null
                  }
                  onChange={(
                    _: SyntheticEvent<Element>,
                    value: {
                      label: string;
                      value: string;
                    } | null,
                  ) =>
                    setValue('llm_model_name', value?.value || '', {
                      shouldDirty: true,
                      shouldValidate: true,
                    })
                  }
                  options={llmModelOptions}
                  noOptionsText={`No llm models Found`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!fieldState.error}
                      helperText={fieldState?.error?.message || ''}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      placeholder="Select LLM model"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          padding: '0px 8px',
                        },
                      }}
                    />
                  )}
                  disabled={false}
                />
              </FormControl>
            )}
            name="llm_model_name"
          />
        </Grid>
        <Grid item sm={12} lg={6}>
          <Controller
            control={control}
            render={({ field, fieldState }) => (
              <FormControl fullWidth>
                <TextField
                  {...field}
                  value={!!field.value.trim() ? field.value : ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message || ''}
                  fullWidth
                  placeholder="Please enter token size"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  disabled={false}
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 10px',
                    },
                  }}
                />
              </FormControl>
            )}
            name="token_size"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BuildWiseGPTForm;
